import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _745e5d88 = () => interopDefault(import('../../../pages/accounts/index.vue' /* webpackChunkName: "pages/accounts/index" */))
const _1cc7ebf0 = () => interopDefault(import('../../../pages/clients/index.vue' /* webpackChunkName: "pages/clients/index" */))
const _cfdb4362 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _d898a0ac = () => interopDefault(import('../../../pages/handouts/index.vue' /* webpackChunkName: "pages/handouts/index" */))
const _5833acde = () => interopDefault(import('../../../pages/selectCompany.vue' /* webpackChunkName: "pages/selectCompany" */))
const _e2de19b2 = () => interopDefault(import('../../../pages/staffJoin.vue' /* webpackChunkName: "pages/staffJoin" */))
const _1a225506 = () => interopDefault(import('../../../pages/admin/companySettings.vue' /* webpackChunkName: "pages/admin/companySettings" */))
const _3c0a9d8a = () => interopDefault(import('../../../pages/admin/manage/index.vue' /* webpackChunkName: "pages/admin/manage/index" */))
const _22884176 = () => interopDefault(import('../../../pages/clients/actions/index.vue' /* webpackChunkName: "pages/clients/actions/index" */))
const _dfb31bd6 = () => interopDefault(import('../../../pages/clients/map/index.vue' /* webpackChunkName: "pages/clients/map/index" */))
const _622a7954 = () => interopDefault(import('../../../pages/clients/new.vue' /* webpackChunkName: "pages/clients/new" */))
const _791f9b49 = () => interopDefault(import('../../../pages/admin/manage/new.vue' /* webpackChunkName: "pages/admin/manage/new" */))
const _24a2694f = () => interopDefault(import('../../../pages/clients/actions/future.vue' /* webpackChunkName: "pages/clients/actions/future" */))
const _196e3165 = () => interopDefault(import('../../../pages/admin/company/_id.vue' /* webpackChunkName: "pages/admin/company/_id" */))
const _76663e9e = () => interopDefault(import('../../../pages/clients/_clientId/index.vue' /* webpackChunkName: "pages/clients/_clientId/index" */))
const _b18ce004 = () => interopDefault(import('../../../pages/staff/_staffId.vue' /* webpackChunkName: "pages/staff/_staffId" */))
const _03f7800c = () => interopDefault(import('../../../pages/clients/_clientId/actions/index.vue' /* webpackChunkName: "pages/clients/_clientId/actions/index" */))
const _711afd79 = () => interopDefault(import('../../../pages/clients/_clientId/actions/future.vue' /* webpackChunkName: "pages/clients/_clientId/actions/future" */))
const _82182b4c = () => interopDefault(import('../../../pages/clients/_clientId/actions/new.vue' /* webpackChunkName: "pages/clients/_clientId/actions/new" */))
const _555a418d = () => interopDefault(import('../../../pages/clients/_clientId/actions/_actionId/index.vue' /* webpackChunkName: "pages/clients/_clientId/actions/_actionId/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/accounts/",
    component: _745e5d88,
    pathToRegexpOptions: {"strict":true},
    name: "accounts___ja"
  }, {
    path: "/clients/",
    component: _1cc7ebf0,
    pathToRegexpOptions: {"strict":true},
    name: "clients___ja"
  }, {
    path: "/en/",
    component: _cfdb4362,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/handouts/",
    component: _d898a0ac,
    pathToRegexpOptions: {"strict":true},
    name: "handouts___ja"
  }, {
    path: "/selectCompany/",
    component: _5833acde,
    pathToRegexpOptions: {"strict":true},
    name: "selectCompany___ja"
  }, {
    path: "/staffJoin/",
    component: _e2de19b2,
    pathToRegexpOptions: {"strict":true},
    name: "staffJoin___ja"
  }, {
    path: "/admin/companySettings/",
    component: _1a225506,
    pathToRegexpOptions: {"strict":true},
    name: "admin-companySettings___ja"
  }, {
    path: "/admin/manage/",
    component: _3c0a9d8a,
    pathToRegexpOptions: {"strict":true},
    name: "admin-manage___ja"
  }, {
    path: "/clients/actions/",
    component: _22884176,
    pathToRegexpOptions: {"strict":true},
    name: "clients-actions___ja"
  }, {
    path: "/clients/map/",
    component: _dfb31bd6,
    pathToRegexpOptions: {"strict":true},
    name: "clients-map___ja"
  }, {
    path: "/clients/new/",
    component: _622a7954,
    pathToRegexpOptions: {"strict":true},
    name: "clients-new___ja"
  }, {
    path: "/en/accounts/",
    component: _745e5d88,
    pathToRegexpOptions: {"strict":true},
    name: "accounts___en"
  }, {
    path: "/en/clients/",
    component: _1cc7ebf0,
    pathToRegexpOptions: {"strict":true},
    name: "clients___en"
  }, {
    path: "/en/handouts/",
    component: _d898a0ac,
    pathToRegexpOptions: {"strict":true},
    name: "handouts___en"
  }, {
    path: "/en/selectCompany/",
    component: _5833acde,
    pathToRegexpOptions: {"strict":true},
    name: "selectCompany___en"
  }, {
    path: "/en/staffJoin/",
    component: _e2de19b2,
    pathToRegexpOptions: {"strict":true},
    name: "staffJoin___en"
  }, {
    path: "/admin/manage/new/",
    component: _791f9b49,
    pathToRegexpOptions: {"strict":true},
    name: "admin-manage-new___ja"
  }, {
    path: "/clients/actions/future/",
    component: _24a2694f,
    pathToRegexpOptions: {"strict":true},
    name: "clients-actions-future___ja"
  }, {
    path: "/en/admin/companySettings/",
    component: _1a225506,
    pathToRegexpOptions: {"strict":true},
    name: "admin-companySettings___en"
  }, {
    path: "/en/admin/manage/",
    component: _3c0a9d8a,
    pathToRegexpOptions: {"strict":true},
    name: "admin-manage___en"
  }, {
    path: "/en/clients/actions/",
    component: _22884176,
    pathToRegexpOptions: {"strict":true},
    name: "clients-actions___en"
  }, {
    path: "/en/clients/map/",
    component: _dfb31bd6,
    pathToRegexpOptions: {"strict":true},
    name: "clients-map___en"
  }, {
    path: "/en/clients/new/",
    component: _622a7954,
    pathToRegexpOptions: {"strict":true},
    name: "clients-new___en"
  }, {
    path: "/en/admin/manage/new/",
    component: _791f9b49,
    pathToRegexpOptions: {"strict":true},
    name: "admin-manage-new___en"
  }, {
    path: "/en/clients/actions/future/",
    component: _24a2694f,
    pathToRegexpOptions: {"strict":true},
    name: "clients-actions-future___en"
  }, {
    path: "/en/admin/company/:id?/",
    component: _196e3165,
    pathToRegexpOptions: {"strict":true},
    name: "admin-company-id___en"
  }, {
    path: "/admin/company/:id?/",
    component: _196e3165,
    pathToRegexpOptions: {"strict":true},
    name: "admin-company-id___ja"
  }, {
    path: "/en/clients/:clientId/",
    component: _76663e9e,
    pathToRegexpOptions: {"strict":true},
    name: "clients-clientId___en"
  }, {
    path: "/en/staff/:staffId?/",
    component: _b18ce004,
    pathToRegexpOptions: {"strict":true},
    name: "staff-staffId___en"
  }, {
    path: "/en/clients/:clientId/actions/",
    component: _03f7800c,
    pathToRegexpOptions: {"strict":true},
    name: "clients-clientId-actions___en"
  }, {
    path: "/en/clients/:clientId/actions/future/",
    component: _711afd79,
    pathToRegexpOptions: {"strict":true},
    name: "clients-clientId-actions-future___en"
  }, {
    path: "/en/clients/:clientId/actions/new/",
    component: _82182b4c,
    pathToRegexpOptions: {"strict":true},
    name: "clients-clientId-actions-new___en"
  }, {
    path: "/en/clients/:clientId/actions/:actionId/",
    component: _555a418d,
    pathToRegexpOptions: {"strict":true},
    name: "clients-clientId-actions-actionId___en"
  }, {
    path: "/clients/:clientId/",
    component: _76663e9e,
    pathToRegexpOptions: {"strict":true},
    name: "clients-clientId___ja"
  }, {
    path: "/staff/:staffId?/",
    component: _b18ce004,
    pathToRegexpOptions: {"strict":true},
    name: "staff-staffId___ja"
  }, {
    path: "/clients/:clientId/actions/",
    component: _03f7800c,
    pathToRegexpOptions: {"strict":true},
    name: "clients-clientId-actions___ja"
  }, {
    path: "/clients/:clientId/actions/future/",
    component: _711afd79,
    pathToRegexpOptions: {"strict":true},
    name: "clients-clientId-actions-future___ja"
  }, {
    path: "/clients/:clientId/actions/new/",
    component: _82182b4c,
    pathToRegexpOptions: {"strict":true},
    name: "clients-clientId-actions-new___ja"
  }, {
    path: "/clients/:clientId/actions/:actionId/",
    component: _555a418d,
    pathToRegexpOptions: {"strict":true},
    name: "clients-clientId-actions-actionId___ja"
  }, {
    path: "/",
    component: _cfdb4362,
    pathToRegexpOptions: {"strict":true},
    name: "index___ja"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
